module.exports = __webpack_public_path__ + "img/title3.0f0a54ca.png";